import { QUERY_CONDITION } from '@/utils/constants';
import QueryFactory, { QueryItem } from '@/utils/helpers/filters/base';
import { formatDateToUTC, getEndOfDay } from '@/utils/helpers/globalHelper';

import { IFilterForm } from '../models';

export class CompanyQueryFactory extends QueryFactory {
  updatedDateFrom(date: string) {
    const newQuerySection = this.initNewQuery(this.data?.length ? QUERY_CONDITION.AND : QUERY_CONDITION.EMPTY);
    newQuerySection?.childrens?.push(new QueryItem().modules.fromDate(date, { fieldTitle: 'updatedDate' }));
    this.append(newQuerySection);
    return this;
  }

  updatedDateTo(date: string) {
    const newQuerySection = this.initNewQuery(this.data?.length ? QUERY_CONDITION.AND : QUERY_CONDITION.EMPTY);
    newQuerySection?.childrens?.push(new QueryItem().modules.toDate(date, { fieldTitle: 'updatedDate' }));
    this.append(newQuerySection);
    return this;
  }
}

export const generateFilter = ({ searchValue, primary }: IFilterForm): string => {
  const filterFactory = new CompanyQueryFactory();

  if (searchValue) {
    const fields = ['nameSearch.ToLower()', 'updatedNameSearch.ToLower()'];
    filterFactory.searchingBy(fields, searchValue.toLowerCase());
  }

  if (primary?.updatedDateFrom) {
    filterFactory.updatedDateFrom(formatDateToUTC(primary.updatedDateFrom));
  }

  if (primary?.updatedDateTo) {
    filterFactory.updatedDateTo(formatDateToUTC(getEndOfDay(primary.updatedDateTo)));
  }

  return filterFactory.sanitize().stringifyData();
};
